import { toast, type SvelteToastOptions } from '@zerodevx/svelte-toast';

const successIcon =
  '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.75 12L10.58 14.83L16.25 9.17004" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

const errorIcon = `<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.16998 14.83L14.83 9.17004" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M14.83 14.83L9.16998 9.17004" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

export const successToast = (message: string, options?: SvelteToastOptions) =>
  toast.push(`<div class="flex flex-row gap-4">${successIcon} ${message}</div>`, {
    theme: {
      '--toastBackground': '#45B26B',
      '--toastColor': '#ffffff',
      '--toastBarBackground': 'olive',
      '--toastContainerBottom': '1em',
      '--toastContainerTop': 'auto',
      '--toastBorderRadius': '12px',
      '--toastPadding': '16px'
    },
    intro: { y: 120 },
    reversed: true,
    ...options
  });

export const errorToast = (message: string, options?: SvelteToastOptions) =>
  toast.push(`<div class="flex flex-row gap-4">${errorIcon} ${message}</div>`, {
    theme: {
      '--toastBackground': '#CA2140',
      '--toastColor': '#ffffff',
      '--toastBarBackground': 'olive',
      '--toastContainerBottom': '1em',
      '--toastContainerTop': 'auto',
      '--toastBorderRadius': '12px',
      '--toastPadding': '16px'
    },
    intro: { y: 120 },
    reversed: true,
    ...options
  });
